import { Screensaver } from 'common/components/screensaver';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';

function ScreensaverPage() {
  // const dispatch = useDispatch<AppDispatch>();
  const handleResume = useCallback(() => {
    // Forcing a full reload to reset the app state and ensure the screensaver is fully exited
    window.location.reload();
    // TODO: Refactor this to properly reset the necessary state without a full reload
    // Commenting out the dispatch for now to prevent potential issues with state management
    // currently rewrites the `lastWatchedChannelId` to original value
    // dispatch(setIdleTimer({ screenSaverActive: false }));
  }, []);

  return <Screensaver onScreensaverResume={handleResume} />;
}

const mapStateToProps = () => ({});

export default React.memo(connect(mapStateToProps, {})(ScreensaverPage));
